import React, { useState } from "react";

import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import { MissingField } from "../../helpers/getFieldsRequired";

interface Props {
  fieldRequired: boolean;
  setFieldsRequired: any;
  missingFields?: MissingField[];
}

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export const SnackbarRequiredFieldError = (props: Props) => {
  const { fieldRequired, setFieldsRequired, missingFields = [] } = props;
  const [open, setOpen] = useState(fieldRequired);

  const missingDocs = missingFields.filter((f) => f.type === "file");
  const missingOtherFields = missingFields.filter((f) => f.type !== "file");

  const onHandleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
    setFieldsRequired(false);
  };

  const buildTitle = () => {
    if (missingDocs.length > 0 && missingOtherFields.length === 0) {
      return "Faltan documentos obligatorios por cargar";
    }
    if (missingDocs.length === 0 && missingOtherFields.length > 0) {
      return "Hay campos obligatorios sin completar";
    }
    return "No es posible enviar el formulario";
  };

  const buildContent = () => {
    const sections: React.ReactNode[] = [];

    if (missingOtherFields.length > 0) {
      sections.push(
        <span key="fields" style={{ display: "block", marginTop: 4 }}>
          Campos pendientes: {missingOtherFields.map((f) => f.label).join(", ")}.
        </span>
      );
    }

    if (missingDocs.length > 0) {
      sections.push(
        <span key="docs" style={{ display: "block", marginTop: 4 }}>
          Documentos pendientes: {missingDocs.map((f) => f.label).join(", ")}.
        </span>
      );
    }

    return sections.length > 0 ? sections : "Complete los campos marcados como requeridos.";
  };

  return (
    <Stack spacing={2} sx={{ width: "100%" }}>
      <Snackbar
        open={open}
        autoHideDuration={12000}
        onClose={onHandleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={onHandleClose}
          severity="warning"
          sx={{ width: "100%", fontSize: "14px", maxWidth: "500px" }}
        >
          <AlertTitle sx={{ fontWeight: "bold", fontSize: "15px" }}>
            {buildTitle()}
          </AlertTitle>
          {buildContent()}
        </Alert>
      </Snackbar>
    </Stack>
  );
};
